<template>
  <div class="row" v-if="rebuild">
    <loading
      class="custom-loading-overlay"
      :active="isLoading"
      :color="loadingColor"
      :isFullPage="true"
    ></loading>
    <div class="col-12" style="padding-left: 5px; padding-right: 5px">
      <div
        class="card card-style"
        style="background-color: white; margin-left: 0px; margin-right: 0px"
      >
        <div class="card-body">
          <h3 class="card-title">Informações pessoais</h3>
          <!-- <div class="form-group">
            <label for="inputField" class="col-form-label">Login:</label>
            <div class="custom-input-container">
              <input
                type="text"
                style="background-color: #efefef"
                v-model="users.login"
                class="custom-input"
                :disabled="isDisabled"
              />
            </div>
          </div> -->
          <div class="form-group">
            <label for="inputField" class="col-form-label">CPF:</label>
            <div class="custom-input-container">
              <input
                type="text"
                disabled
                v-model="users.cpf"
                class="custom-input"
              />
            </div>
          </div>
          <div class="form-group">
            <label for="inputField" class="col-form-label">
              <span class="required">*</span> Telefone:</label
            >
            <div class="custom-input-container">
              <input
                type="tel"
                v-model="users.telefone"
                class="custom-input"
                v-mask="'(99) 99999-9999'"
              />
            </div>
          </div>
          <div class="form-group">
            <label for="inputField" class="col-form-label"
              ><span class="required">*</span> Data de Nascimento:</label
            >
            <div class="custom-input-container">
              <input
                autocomplete="new-password"
                type="date"
                id="Name"
                class="form-control custom-input"
                placeholder="Data de Nascimento"
                v-model="users.paciente.data_nascimento"
              />
            </div>
          </div>
          <div class="form-group">
            <label for="inputField" class="col-form-label">Nome Social:</label>
            <div class="custom-input-container">
              <input
                type="text"
                v-model="users.paciente.nome_social"
                class="custom-input"
                placeholder="Opcional"
              />
            </div>
          </div>
          <div class="form-group">
            <label for="Name"> <span class="required">*</span> Sexo Biológico: </label>
            <select
              class="form-select custom-input"
              type="select"
              v-model="users.paciente.sexo"
            >
              <option value="">Selecione...</option>
              <option value="M">Masculino</option>
              <option value="F">Feminino</option>
              <option value="I">Intersexo</option>
            </select>
          </div>
          <div class="form-group" v-if="users.paciente.sexo === 'I'">
            <label for="inputField" class="col-form-label">Identidade de Gênero:</label>
            <select
              class="form-select custom-input"
              v-model="users.paciente.identidade_genero"
            >
              <option value="">Selecione...</option>
              <option value="M">Masculino</option>
              <option value="F">Feminino</option>
              <option value="NB">Não-binário</option>
              <option value="PNI">Prefiro não informar</option>
              <option value="O">Outro</option>
            </select>
          </div>
          <div
            v-if="users.paciente.sexo === 'I' && users.paciente.identidade_genero === 'O'"
            class="form-group"
          >
            <label for="inputField" class="col-form-label">Qual?</label>
            <div class="custom-input-container">
              <input
                type="text"
                v-model="users.paciente.identidade_genero_outro"
                class="custom-input"
                placeholder="Descreva sua identidade de gênero"
              />
            </div>
          </div>
          <div class="form-group">
            <label for="inputField" class="col-form-label">
              <span class="required">*</span> Telefone/Celular:</label
            >
            <div class="custom-input-container">
              <input
                type="tel"
                class="custom-input"
                v-model="users.paciente.telefone"
                v-mask="'(99) 99999-9999'"
              />
            </div>
          </div>

          <div class="form-group">
            <label for="inputField" class="col-form-label"
              ><span class="required">*</span> Endereço:</label
            >
            <!-- Endereço confirmado: card com todos os dados -->
            <template v-if="addressConfirmed && !editingAddress">
              <div class="custom-input-container">
                <div class="address-confirmed-card">
                  <div class="address-confirmed-icon">
                    <i class="bi bi-geo-alt-fill"></i>
                  </div>
                  <div class="address-confirmed-info">
                    <div class="address-confirmed-main">
                      {{ users.paciente.endereco
                      }}{{
                        users.paciente.numero
                          ? ", " + users.paciente.numero
                          : ""
                      }}
                    </div>
                    <div class="address-confirmed-sub">
                      {{
                        users.paciente.bairro
                          ? users.paciente.bairro + " · "
                          : ""
                      }}{{ users.paciente.cidade }} - {{ users.paciente.uf }}
                    </div>
                    <div
                      class="address-confirmed-sub"
                      v-if="users.paciente.cep || users.paciente.complemento"
                    >
                      <span v-if="users.paciente.cep"
                        >CEP {{ users.paciente.cep }}</span
                      >
                      <span
                        v-if="users.paciente.cep && users.paciente.complemento"
                      >
                        ·
                      </span>
                      <span v-if="users.paciente.complemento">{{
                        users.paciente.complemento
                      }}</span>
                    </div>
                  </div>
                  <button
                    type="button"
                    class="address-confirmed-change"
                    @click="editingAddress = true"
                  >
                    alterar
                  </button>
                </div>
              </div>
            </template>

            <!-- Modo edição: busca novo endereço + campos editáveis -->
            <template v-else-if="!addressConfirmed || editingAddress">
              <div class="custom-input-container">
                <div class="places-search-wrapper">
                  <i class="bi bi-search places-search-icon"></i>
                  <GmapAutocomplete
                    :key="autocompleteKey"
                    ref="placesInput"
                    :options="{
                      types: ['address'],
                      componentRestrictions: { country: 'br' },
                      fields: [
                        'address_components',
                        'geometry',
                        'formatted_address'
                      ]
                    }"
                    @place_changed="onPlaceChanged"
                    class="form-control places-input custom-input"
                    placeholder="Digite o endereço ou local..."
                  />
                </div>
              </div>
              <div class="row mt-2" v-if="addressConfirmed">
                <div class="col-6 pr-1">
                  <input
                    type="text"
                    id="inputNumero"
                    v-model="users.paciente.numero"
                    class="custom-input"
                    placeholder="Número"
                  />
                </div>
                <div class="col-6 pl-1">
                  <input
                    type="text"
                    v-model="users.paciente.complemento"
                    class="custom-input"
                    placeholder="Complemento"
                  />
                </div>
                <div class="col-12 mt-2">
                  <button
                    type="button"
                    class="btn-confirm-address"
                    @click="editingAddress = false"
                  >
                    Confirmar endereço
                  </button>
                </div>
              </div>
            </template>
          </div>
          <div class="form-group">
            <label for="inputField" class="col-form-label"
              >Você possui alguma deficiência ou necessidade específica de
              acessibilidade?</label
            >
            <div class="custom-input-container">
              <textarea
                v-model="users.paciente.deficiencia_descricao"
                style="height: 83px"
                maxlength="260"
                class="custom-input"
              />
            </div>
          </div>
          <div class="form-group">
            <label for="inputField" class="col-form-label"
              ><span class="required">*</span> E-mail:</label
            >
            <div class="custom-input-container">
              <input type="email" v-model="users.email" class="custom-input" />
            </div>
          </div>

          <br />
          <div @click="save()" class="form-group botao-salvar">
            <div class="col-md-12">
              <button type="button" class="btn">SALVAR</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Loading from "vue-loading-overlay";
export default {
  data() {
    return {
      users: {
        usuario_nome: "",
        login: "",
        senha: "",
        perfil_id: "",
        senha_confirmacao: "",
        paciente: {
          endereco: "",
          numero: "",
          cep: "",
          cidade: "",
          uf: "",
          complemento: "",
          bairro: "",
          telefone: "",
          nome_social: "",
          identidade_genero: "",
          identidade_genero_outro: "",
        },
      },
      addressConfirmed: false,
      editingAddress: false,
      autocompleteKey: 0,
      isLoading: false,
      loadingColor: "#5D9CEC",
      isDisabled: true,
      rebuild: true,
      change_password: false
    };
  },
  watch: {
    "users.paciente.sexo"(newValue) {
      if (newValue !== "I") {
        this.users.paciente.identidade_genero = "";
        this.users.paciente.identidade_genero_outro = "";
      }
    }
  },
  computed: {},
  methods: {
    toggleFormSenha() {
      const self = this;
      if (self.change_password) {
        self.change_password = false;
      } else {
        self.change_password = true;
      }
    },
    onPlaceChanged(place) {
      if (!place || !place.geometry) {
        return;
      }

      const components = place.address_components || [];
      this.applyAddressComponents(components, place.formatted_address);
    },
    applyAddressComponents(components, formattedAddress) {
      const get = (type, useShort = false) => {
        const component = components.find(item => item.types.includes(type));
        return component
          ? useShort
            ? component.short_name
            : component.long_name
          : "";
      };

      const logradouro = get("route") || (formattedAddress || "").split(",")[0];
      const bairro =
        get("sublocality_level_1") || get("sublocality") || get("neighborhood");
      const cidade =
        get("administrative_area_level_2") ||
        get("locality") ||
        get("administrative_area_level_1");

      this.users.paciente.endereco = logradouro;
      this.users.paciente.numero = get("street_number");
      this.users.paciente.bairro = bairro;
      this.users.paciente.cidade = cidade;
      this.users.paciente.uf = get("administrative_area_level_1", true);
      this.users.paciente.cep = (get("postal_code") || "").replace(
        /[^0-9]/g,
        ""
      );

      this.addressConfirmed = Boolean(
        this.users.paciente.endereco &&
          this.users.paciente.cidade &&
          this.users.paciente.uf
      );
      this.editingAddress = this.addressConfirmed;

      this.$nextTick(() => {
        const inputNumero = document.getElementById("inputNumero");
        if (inputNumero) {
          inputNumero.focus();
        }
      });
    },
    clearAddress() {
      this.addressConfirmed = false;
      this.editingAddress = false;
      this.autocompleteKey += 1;
      this.users.paciente.endereco = "";
      this.users.paciente.numero = "";
      this.users.paciente.cep = "";
      this.users.paciente.cidade = "";
      this.users.paciente.uf = "";
      this.users.paciente.complemento = "";
      this.users.paciente.bairro = "";
    },
    syncAddressConfirmation() {
      this.addressConfirmed = Boolean(
        this.users &&
          this.users.paciente &&
          this.users.paciente.endereco &&
          this.users.paciente.cidade &&
          this.users.paciente.uf
      );
      this.editingAddress = false;
    },
    /* changeStatusReceive(object) {
      const self = this;
      const api = self.$store.state.api + "teste";

      self.isLoading = true;

      self.$http
        .post(api, object)
        .then((response) => {})
        .catch((error) => {
          self.$message("Erro", error.response.data, "error");
        });
    }, */
    // makeFormData: function () {
    //   const self = this;
    //   let fd = new FormData();

    //   let photo = document.getElementById("userPic");

    //   fd.append("usuario_nome", self.users.usuario_nome);
    //   fd.append("login", self.users.login);
    //   fd.append("perfil_id", self.users.perfil_id);
    //   fd.append("senha", self.users.senha);
    //   fd.append("senha_confirmacao", self.users.senha_confirmacao);
    //   fd.append(
    //     "endereco",
    //     self.users.endereco ? self.users.endereco : ""
    //   );
    //   fd.append("numero", self.users.numero ? self.users.numero : "");
    //   fd.append("cep", self.users.cep ? self.users.cep : "");
    //   fd.append("cidade", self.users.cidade ? self.users.cidade : "");
    //   fd.append("uf", self.users.uf ? self.users.uf : "");
    //   fd.append(
    //     "complemento",
    //     self.users.complemento ? self.users.complemento : ""
    //   );
    //   fd.append("bairro", self.users.bairro ? self.users.bairro : "");
    //   fd.append(
    //     "deficiencia",
    //     self.users.deficiencia ? self.users.deficiencia : ""
    //   );

    //   // fd.append("foto", photo.files[0] ? photo.files[0] : "");

    //   if (self.users.id) {
    //     fd.append("id", self.users.id);
    //     fd.append("_method", "PUT");
    //   }

    //   return fd;
    // },
    save() {
      const self = this;
      self.isLoading = true;
      let api = self.$store.state.api + "users";

      // let fd = self.makeFormData();

      if (self.users.id) {
        self.users._method = "PUT";
        api += "/" + self.users.id;
      }
      axios
        .post(api, self.users)
        .then(response => {
          self.isLoading = false;
          self.$message(
            "Sucesso",
            `Informações guardadas com sucesso`,
            "success"
          );
          this.$router.push("/dashboard");          
          this.$store.commit('profileUpdate');
        })
        .catch(error => {
          self.isLoading = false;
          self.$message(null, error.response.data, "error");
        });
    },
    getUsers(id) {
      const self = this;
      const api = self.$store.state.api + "users/" + id + "?with[]=paciente";

      axios
        .get(api)
        .then(response => {
          self.users = response.data.data[0];
          delete self.users.foto;
          if (!self.users.paciente) {
            self.users.paciente = {
              endereco: "",
              numero: "",
              cep: "",
              cidade: "",
              uf: "",
              complemento: "",
              bairro: "",
              telefone: self.users.telefone
            };
          } else {
            self.users.paciente.cidade = self.users.paciente.nome_municipio;
            self.users.paciente.uf = self.users.paciente.nome_estado;
          }
          self.syncAddressConfirmation();
          self.isLoading = false;
        })
        .catch(error => {
          self.$message(null, error.response.data, "error");
          self.isLoading = false;
        });
    }
  },
  components: { Loading },
  props: {},
  mounted() {
    const self = this;
    self.isLoading = true;

    $("#menu-main").removeClass("show");
    $(".offcanvas-backdrop.show").removeClass("show");
    /* $(".theme-light").removeAttribute("style","overflow: hidden; padding-right: 0px;"); */
    document.body.setAttribute("style", null);

    setTimeout(() => {
      let id = self.$store.state.user.usuario_id;
      console.log("dasdasdas", id);
      if (id) {
        /* self.change_password = false; */
        self.getUsers(id);
      }
    }, 1000);
  }
};
</script>
<style scoped>
/* CUSTOMIZACOES VUE LOADING */
.custom-loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0);
  backdrop-filter: blur(3px);
  opacity: 0.98;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.custom-loading-spinner {
  width: 100px;
  height: 100px;
  z-index: 10000;
}

/* CUSTOMIZACOES INPUTS */
.custom-input {
  border-radius: 0;
}

.input-group {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;
  width: 100%;
}

.input-group > .form-control {
  position: relative;
  flex: 1 1 auto;
  width: 1%;
  margin-bottom: 0;
}

.input-group > .form-control:focus {
  z-index: 3;
}

.custom-input-container {
  position: relative;
}

.custom-input {
  padding: 0.375rem 0.75rem;
  height: 2.714rem;
  font-size: 1rem;
  line-height: 1.5;
  color: #495057;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  box-shadow: 0 0.2rem 0.5rem rgba(0, 0, 0, 0.15);
  width: 100%;
}

.custom-input:focus {
  border-color: #80bdff;
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}

.botao-salvar {
  position: fixed;
  bottom: 0;
  width: 100%;
  padding-left: 10px;
  padding-right: 10px;
}

.btn {
  width: 100% !important;
  background-color: rgb(21, 72, 138) !important;
  margin: 0px 15px 18px -29px;
}

.btn2 {
  width: 100% !important;
  background-color: rgb(21, 72, 138) !important;
  color: #fff !important;
  font-family: "Inter", sans-serif;
  text-transform: uppercase;
  font-weight: 700;
  border-radius: 12px;
  font-size: 12px;
  padding: 14px 20px;
  box-shadow: 0 5px 14px 0 rgba(0, 0, 0, 0.1);
}

.form-group {
  margin-bottom: 9px !important;
}

.places-search-wrapper {
  position: relative;
}

.places-search-icon {
  position: absolute;
  top: 50%;
  left: 14px;
  transform: translateY(-50%);
  color: #7a8699;
  z-index: 2;
}

.places-input {
  padding-left: 40px;
}

.pac-container {
  z-index: 99999 !important;
}

.address-confirmed-card {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px 16px;
  border: 1px solid #d9e2ec;
  border-radius: 14px;
  background: #f8fbff;
}

.address-confirmed-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 38px;
  height: 38px;
  border-radius: 12px;
  background: rgba(21, 72, 138, 0.12);
  color: rgb(21, 72, 138);
  font-size: 18px;
}

.address-confirmed-info {
  flex: 1;
  min-width: 0;
}

.address-confirmed-main {
  font-weight: 700;
  color: #233142;
}

.address-confirmed-sub {
  color: #52606d;
  font-size: 13px;
}

.address-confirmed-change {
  border: 0;
  background: transparent;
  color: rgb(21, 72, 138);
  font-size: 13px;
  font-weight: 700;
  text-transform: lowercase;
  white-space: nowrap;
}

.btn-confirm-address {
  width: 100%;
  background-color: rgb(21, 72, 138);
  color: #fff;
  border: 0;
  border-radius: 10px;
  padding: 10px 0;
  font-weight: 700;
  font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// src/components/EditarPerfil.vue